import { useCallback, useEffect, useState } from 'react'
import type { PostCard } from '../types'
import type { PublishFilters } from '../types/publish'
import { getPublishFeedPage } from '../api/publish'

export function usePublish(filters?: PublishFilters) {
  const [items, setItems] = useState<PostCard[] | null>(null)
  const [next, setNext] = useState<string | null>(null)
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState<string | null>(null)

  const load = useCallback(async (cursor?: string | null) => {
    setLoading(true)
    try {
      const { items: page, next } = await getPublishFeedPage(cursor, filters)
      setItems((prev) => (prev ? (cursor ? [...prev, ...page] : page) : page))
      setNext(next ?? null)
    } catch (e: any) {
      setError(e?.message || 'Failed to load')
    } finally {
      setLoading(false)
    }
  }, [filters])

  useEffect(() => {
    // Reset on filters change
    setItems(null)
    setNext(null)
    setError(null)
    void load(null)
  }, [load])

  const loadMore = useCallback(async () => {
    if (!next || loading) return
    await load(next)
  }, [next, loading, load])

  return { items, error, loading, hasMore: Boolean(next), loadMore }
}

